export const CUSTOM_FIELD_MODEL_VALUES = {
    CASE: "Case",
    COMPANY: "Company",
    RESPONDENT: "Respondent",
};
export const CUSTOM_FIELD_MODELS = [
    {
        key: "CUSTOM_FIELD_CASE",
        label: "Case",
        value: CUSTOM_FIELD_MODEL_VALUES.CASE,
    },
    {
        key: "CUSTOM_FIELD_COMPANY",
        label: "Company",
        value: CUSTOM_FIELD_MODEL_VALUES.COMPANY,
    },
    {
        key: "CUSTOM_FIELD_RESPONDENT",
        label: "Respondent",
        value: CUSTOM_FIELD_MODEL_VALUES.RESPONDENT,
    },
];
//# sourceMappingURL=customFieldModels.js.map